import {
  startLoadingChats,
  setChats,
  setErrorChat,
  setTokenChat,
  setUnreadMessages,
} from "./chatsSlice";
import { adminAPI } from "../../api/adminAPI";

// const { get, post } = useAPI();

export const getTokenFromAPI = () => {
  return async (dispatch, actualState) => {
    const { status, data } = await adminAPI.get("/chat/token", {
      headers: {
        "x-token": actualState().auth.jwt,
        "Cache-Control": "no-cache",
      },
    });
    if (status !== 200) {
      return;
    }
    dispatch(setTokenChat({ tokenChat: data.token }));
    return;
  };
};

export const setTokenChatToAPI = ({ sid = "", idService = "" }) => {
  return async (dispatch, actualState) => {
    const { status, data } = await adminAPI.post(
      "/chat/save-conversations",
      {
        sid,
        idService,
      },
      {
        headers: {
          "x-token": actualState().auth.jwt,
          "Cache-Control": "no-cache",
        },
      }
    );
    if (status !== 200) {
      return;
    }
    dispatch(setTokenChat({ tokenChat: sid }));
    return;
  };
};

export const getConversationsFromAPI = (page = 1, limit = 10) => {
  return async (dispatch, actualState) => {
    dispatch(startLoadingChats());
    const { status, data } = await adminAPI
      .get(`/chat?page=${page}&limit=${limit}`, {
        headers: {
          "x-token": actualState().auth.jwt,
          "Cache-Control": "no-cache",
        },
      })
      .catch(({ response }) => response);
    if (status !== 200) {
      dispatch(setErrorChat({ message: data.message }));
      return;
    }

    dispatch(setChats({ chats: data.data, pagination: data.pagination }));
    return;
  };
};

export const getUnreadMessagesFromAPI = () => {
  return async (dispatch, actualState) => {
    const { status, data } = await adminAPI
      .get("/chat/unread-messages", {
        headers: {
          "x-token": actualState().auth.jwt,
          "Cache-Control": "no-cache",
        },
      })
      .catch(({ response }) => response);

    if (status !== 200) {
      dispatch(setErrorChat({ message: data.message }));
      return;
    }
    if (data.data <= 0) {
      data.data = null;
    }
    dispatch(setUnreadMessages({ unreadMessages: data.data }));
    return;
  };
};
